import { IconX } from "@tabler/icons-react";
import type { FC } from "react";
import { Button as AriaButton } from "react-aria-components";

export interface ModalCloseButtonProps {
  onPress?: () => void;
}

/** Button intended to be used in the top right corner of a modal or slideover. */
export const ModalCloseButton: FC<ModalCloseButtonProps> = (props) => (
  // The outer <div> avoids any negative margins from being overridden.
  <div className="flex-none">
    <AriaButton
      slot="close"
      className="-my-2 -mr-2 block p-2 text-gray-400 hover:text-muted-foreground"
      aria-label="Close"
      onPress={props.onPress}
    >
      <IconX className="size-5 flex-none" />
    </AriaButton>
  </div>
);
